module.exports = __webpack_public_path__ + "static/img/rank_background_official copy.9cebeebf.png";